export function getSubscriptionStatus(subscription: number): boolean {
  const now = Math.floor(Date.now() / 1000);
  const secondsLeft = subscription - now;

  if (secondsLeft <= 0) {
    return true;
  }

  // const daysLeft = Math.floor(secondsLeft / 86400); // 86400 = 1 day in seconds

  // if (daysLeft <= 3) {
  //   return 'expiring_soon';
  // }

  return false;
}
